export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'What is a Kundali?',
    answer:
      'A Kundali (also called Janam Kundali or birth chart) is a Vedic astrological chart that maps the positions of planets at the exact time, date, and place of your birth. It is used in Jyotish (Indian astrology) to understand your personality, life path, karma, and destiny.',
  },
  {
    question: 'What is Dosha in Vedic astrology?',
    answer:
      'A Dosha in Vedic astrology is an unfavorable planetary combination in a birth chart that may cause challenges in specific areas of life. Common Doshas include Mangal Dosha (Mars affliction affecting marriage), Kaal Sarp Dosha (all planets between Rahu and Ketu), and Pitra Dosha (ancestral karmic debt). KundaliAI analyzes your chart for all major Doshas and suggests remedies.',
  },
  {
    question: 'How does Kundali matching work for marriage compatibility?',
    answer:
      'Kundali matching (Kundali Milan) compares two birth charts using the Ashtakoota system — 8 criteria scored out of 36 points. A score of 18+ is generally considered compatible. KundaliAI performs detailed compatibility analysis including Guna matching, Mangal Dosha check, and planetary compatibility assessment.',
  },
  {
    question: 'What Vedic astrology predictions does KundaliAI provide?',
    answer:
      'KundaliAI provides personalized Vedic astrology predictions including daily horoscope, weekly and monthly forecasts, yearly predictions, Dasha (planetary period) analysis, transit effects, and life event predictions for career, relationships, health, and finances — all based on your individual Kundali.',
  },
  {
    question: 'What are Vedic remedies for planetary afflictions?',
    answer:
      'Vedic remedies are traditional practices recommended to mitigate the negative effects of planetary afflictions in your Kundali. They include gemstone recommendations, mantra chanting, fasting on specific days, charitable acts, and performing specific pujas. KundaliAI provides personalized remedy suggestions based on your unique birth chart analysis.',
  },
  {
    question: 'Is KundaliAI free to use?',
    answer:
      'KundaliAI offers a free tier allowing you to explore AI-powered Vedic astrology consultations. Premium plans are available for unlimited access to Kundali generation, detailed predictions, compatibility reports, Dosha analysis, and personalized remedies.',
  },
];

export function buildFaqSchema(): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };
}
